$(function () {
    var $container = $('.header-notifications');
    var $handler =  $('.notifications-icon');
    var $typeHandler = $container.find('.notifications-header a');
    var selectedType = $container.find('.notifications-header a.active').data('type');

    $container.hide();
    hideNotifications();

    if ($(window).width() <= 767) {
        var height = $(window).height();
        $container.find('.notifications-messages').css('height', height - 240);
    }

    $handler.on('click', function (e) {
        e.preventDefault();
        if ($container.is(':hidden')) {
            $.get('/notifications/latest', function (data) {
                $('.js-notifications-counter').text(data.count);
                $('.js-inbox-counter').text(data.total);
                $container.find('.notifications-messages').html(data.html);
            });
        }

        $container.toggle();
    });

    $typeHandler.on('click', function (e) {
        e.preventDefault();
        $typeHandler.removeClass('active');
        $(this).addClass('active');
        selectedType = $(this).data('type');
        hideNotifications();
    });

    $container.on('click', '.notification', function () {
        var url = $(this).closest('.notification').data('url');

        window.location.href = url;
    });

    $(document).on('click', function (e) {
        if (!$container.is(e.target) && $container.has(e.target).length === 0 && !$handler.is(e.target)) {
            $container.hide();
        }
    });

    function hideNotifications() {
        if (selectedType === undefined) {
            $container.find('.notification').removeClass('d-none');
            $container.find('.notification').addClass('d-flex');
            return;
        }

        $container.find('.notification').each(function () {
            if ($(this).data('type') !== selectedType) {
                $(this).removeClass('d-flex');
                $(this).addClass('d-none');
            } else {
                $(this).removeClass('d-none');
                $(this).addClass('d-flex');
            }
        });
    }
});
